import React, { cloneElement } from "react";
import { Card } from "components/ui";
import Logo from "components/template/Logo";
import LanguageSelector from "components/template/LanguageSelector";

const Simple = ({ children, content, hideLogo, ...rest }) => {
  return (
    <div className="flex-1">
      <div className="flex justify-end items-baseline p-5 max-w-7xl mx-auto">
        <LanguageSelector withText />
      </div>
      <div className="flex flex-col items-center justify-start gap-5 p-5">
        {/* <div className="text-center max-w-xs pb-5">
          <Logo imgClass="mx-auto" />
        </div> */}
        <Card
          className="min-w-[320px] md:min-w-[450px]"
          bodyClass="md:pb-10 md:px-10"
        >
          {!hideLogo && (
            <div className="w-[200px] mx-auto mb-10">
              <Logo />
            </div>
          )}
          <div className="text-center">
            {content}
            {children
              ? cloneElement(children, {
                  contentClassName: "text-center",
                  ...rest,
                })
              : null}
          </div>
        </Card>
      </div>
    </div>
  );
};

export default Simple;
